module.exports = __webpack_public_path__ + "static/media/intro.5838e8e0.mp4";